import type { VideoSource } from 'expo-video';

// Registry for the bundled evergreen hero video. The asset lives in each fhs
// app (embedded in the binary via `assetBundlePatterns`) rather than in this
// shared package, so the app registers its own `require(...)`'d source at
// startup — before the hero is prefetched or a layer mounts.
let evergreenVideoSource: VideoSource | null = null;

export function registerEvergreenVideoSource(source: VideoSource): void {
  evergreenVideoSource = source;
}

export function getEvergreenVideoSource(): VideoSource {
  if (evergreenVideoSource == null) {
    throw new Error(
      'Evergreen hero video source not registered — call registerEvergreenVideoSource() at app startup.'
    );
  }
  return evergreenVideoSource;
}
